import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  
  class TarefasEnvolveService extends Service {
    constructor() {
      super();
  
      this.url = env.url + "envolve";
    }

    async getEnvolve() {
      const init = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.adquirirToken()
        }
      }
      const response = await fetch(this.url, init)
      if (response.ok) {
        return response;
      }
      if (response.status === 401) {
        acessoUtils.redirecionarSemTokenParaLogin();
      }
      throw new Error('HTTP ' + response.status)
    }
  }
  
  export const tarefasEnvolveService = new TarefasEnvolveService()
  